/**
 * Indicates the index of the toast in the list.
 * @type {number}
 */
export const index = '--toast-index';
/**
 * Indicates the vertical pixels offset of the toast in the list when expanded.
 * @type {number}
 */
export const offsetY = '--toast-offset-y';
/**
 * Indicates the measured natural height of the toast in pixels.
 * @type {number}
 */
export const height = '--toast-height';
/**
 * Indicates the horizontal swipe movement of the toast.
 * @type {number}
 */
export const swipeMovementX = '--toast-swipe-movement-x';
/**
 * Indicates the vertical swipe movement of the toast.
 * @type {number}
 */
export const swipeMovementY = '--toast-swipe-movement-y';
